<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row v-if="!hasCentroCusto">
                <rkm-col cols="6">
                    <rkm-form-input
                        label="Unidade"
                        v-model="form.unidade"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        label="Local de atendimento"
                        v-model="form.infraestrutura"
                        disabled
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row class="flex-nowrap">
                <rkm-col
                    v-if="!hasCentroCusto"
                    cols="6"
                >
                    <rkm-form-select
                        :options="form.centrosCusto"
                        :validations="validations.centroCusto"
                        label="Setor"
                        v-model="model.centroCustoId"
                        value-field="id"
                        text-field="setor"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col
                    :cols="hasCentroCusto ? 'auto' : 6"
                    :class="{ 'flex-grow-1': hasCentroCusto }"
                >
                    <rkm-form-input
                        :validations="validations.nome"
                        label="Nome"
                        uppercase
                        v-model="model.nome"
                    />
                </rkm-col>

                <rkm-col
                    class="flex-grow-0 text-nowrap"
                    v-if="hasCentroCusto"
                >
                    <rkm-button
                        v-if="index !== null"
                        color="primary"
                        :label="false"
                        @click.stop="$refs.Form.validate(update)"
                    >
                        Salvar
                    </rkm-button>

                    <rkm-button
                        v-else
                        color="primary"
                        :label="false"
                        @click.stop="$refs.Form.validate(add)"
                    >
                        Incluir
                    </rkm-button>

                    <rkm-button
                        color="danger"
                        :label="false"
                        @click.stop="resetForm"
                    >
                        {{ index !== null ? 'Cancelar' : 'Limpar' }}
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            v-if="hasCentroCusto"
            :fields="fields.datatables.list"
            :items="centroCusto.salas"
            ref="Table"
        >
            <template v-slot:cell(actions)="row">
                <rkm-button
                    color="primary"
                    title="Editar"
                    small
                    @click.stop="handleEdit(row)"

                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    color="danger"
                    title="Excluir"
                    small
                    @click.stop="handleDestroy(row)"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                nome: {
                    required: true,
                    max: 30,
                    min: 3,
                },
                centroCusto: {
                    required: true,
                }
            }
        },
        fields() {

            return {
                datatables: {
                    list: [
                        {
                            key: 'nome',
                            label: 'Nome',
                            sortable: true,
                        },
                        {
                            key: 'actions',
                            label: 'Ações',
                            class: 'col-min'
                        },
                    ],
                },
            }
        },
        hasCentroCusto() {

            return !!this.centroCusto
        }
    },
    created() {

        this.repositories = {
            sala: this.getConectaSusRepository('cadastro.estabelecimento.sala')
        }

        this.load()
    },
    data: () => ({
        index: null,
        form: {},
        model: {}
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (this.hasCentroCusto) {

                this.model = { id: null, nome: null }

                return
            }

            this.setLoading()

            const request = this.id
                ? this.repositories.sala.edit(this.id)
                : this.repositories.sala.create()

            request
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.sala.update(this.id, this.prepareData())
                        : this.repositories.sala.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            return this.camelObjectKeysToSnakeRecursive(this.clone(this.model))
        },
        add() {

            this.validateDuplicity()
                .then(valid => {

                    if (!valid) return

                    this.centroCusto.salas.push(this.clone(this.model))

                    this.resetForm()
                })
        },
        update() {

            this.validateDuplicity()
                .then(valid => {

                    if (!valid) return

                    this.centroCusto.salas[this.index] = this.clone(this.model)

                    this.resetForm()
                    this.$refs.Table.refresh()
                })
        },
        async validateDuplicity() {

            const hasSetor = this.centroCusto.salas
                .find((s, index) => s.nome === this.model.nome && index !== this.index)

            if (hasSetor) {

                this.showValidationNotification('A sala já existe.')

                return false
            }

            return true
        },
        resetForm() {

            this.index = null

            this.model.id = null
            this.model.nome = null

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        handleEdit({ index, item }) {

            this.index = index

            this.model.id = item.id
            this.model.nome = item.nome
        },
        handleDestroy({ index }) {

            const destroy = async () => {

                this.centroCusto.salas.splice(index, 1)

                if (index === this.index) {

                    this.resetForm()
                }
            }

            this.showDeleteConfirmation('Deseja realmente excluir a sala?', destroy)
        },
    },
    mixins: [repository, stringCase, object, error],
    props: {
        id: { type: Number },
        centroCusto: { type: Object },
    },
}
</script>